module.exports = __webpack_public_path__ + "static/img/021未弃用环保局官网.0286cdc.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/smPicImgs/021未弃用环保局官网.jpg
// module id = g9iR
// module chunks = 0